import DeclensionUtils from 'application/utils/DeclensionUtils';

export const TEXTS = {
  CHANGE_PRICE_PLAN_PERIOD_MODAL_TITLE: 'Смена периода оплаты',
  CHANGE_PRICE_PLAN_PERIOD_MODAL_DESCRIPTION: 'Выберите период оплаты:',
  CHANGE_PRICE_PLAN_PERIOD_MODAL_BUTTON_SUBMIT: 'Сменить',
  CHANGE_PRICE_PLAN_PERIOD_MODAL_BUTTON_CANCEL: 'Отменить',
  CHANGE_PRICE_PLAN_PERIOD_MODAL_SUCCESS: 'Период оплаты изменен',
  CHANGE_PRICE_PLAN_PERIOD_MODAL_ERROR: 'Не удалось изменить период оплаты',

  CHANGE_PRICE_PLAN_PERIOD_AMOUNT: (amount: string | number) => `${amount} ₽`,
  CHANGE_PRICE_PLAN_PERIOD_FIRST_DEBITING_TEXT: (title: string) => `Ваше первое ${title} за `,
  CHANGE_PRICE_PLAN_PERIOD_FIRST_DEBITING_POINT_COUNT_TEXT: (count: number) =>
    `${count} адрес${DeclensionUtils.pluralEnding(count)} `,
  CHANGE_PRICE_PLAN_PERIOD_FIRST_DEBITING_DATE: (dateStr: string) => `в подписке будет ${dateStr}`,

  CHANGE_PRICE_PLAN_PERIOD_TEXT_FOR_INACTIVE_STATUS: 'На текущий момент у вас создано ',
};
